import { gql } from "@/services/httpAdapter";

import { SpecialUnitsRulesFragment } from "../fragments/specialUnits";

export const onUpdateCommissionCyclesCount = gql`
	subscription onUpdateCommissionCyclesCount {
		onUpdateCommissionCyclesCount {
			_id
			title
			startDate
			status
			endDate
			specialUnitsList {
				specialUnitsListId {
					_id
					title
					createdBy {
						_id
						fullName
					}
					createdAt
					unitsCount
					specialUnitsListType
				}
			}
		}
	}
`;

export const onSpecialUnitsListModification = gql`
	subscription onSpecialUnitsListModification($commissionCycleId: String!) {
		onSpecialUnitsListModification(commissionCycleId: $commissionCycleId) {
			commissionCycleId
		}
	}
`;

export const onDeleteSpecialUnitsList = gql`
	subscription onDeleteSpecialUnitsList($commissionCycleId: String!) {
		onDeleteSpecialUnitsList(commissionCycleId: $commissionCycleId) {
			commissionCycleId
		}
	}
`;

export const onCreateSpecialUnitsSetup = gql`
	subscription onCreateSpecialUnitsList($unitListId: String) {
		onCreateSpecialUnitsList(unitListId: $unitListId) {
			_id
			title
			unitsCount
			createdBy {
				fullName
			}
			createdAt
			lastModifiedBy {
				fullName
			}
			lastModifiedOn
			specialUnitsListType
		}
	}
`;

export const onDeleteSpecialUnitsSetup = gql`
	subscription onDeleteSpecialUnitsList($_id: String, $commissionCycleId: String) {
		onDeleteSpecialUnitsList(_id: $_id, commissionCycleId: $commissionCycleId) {
			_id
			commissionCycleId
		}
	}
`;

export const onUpdateSpecialUnitsSetup = gql`
	subscription onUpdateSpecialUnitsList($_id: String) {
		onUpdateSpecialUnitsList(_id: $_id) {
			_id
			title
			unitsCount
			effectiveDateFrom
			effectiveDateTo
			units {
				commission {
					input
					value
				}
				createdBy {
					fullName
				}
				createdAt
				_id
				description
				lastModifiedOn
				stockNumber
				hierarchy
				isParent
				search
				criteria
				inventoryList {
					_id
					hierarchy
					isParent
					inventory {
						_id
						createdAt
						locationId
						status
						properties {
							displayName
							dataType
							value
						}
						updatedAt
						averageAge
					}
				}
			}
			createdBy {
				fullName
			}
			createdAt
			lastModifiedBy {
				fullName
			}
			lastModifiedOn
			rules {
				...SpecialUnitsRules
			}
		}
	}
	${SpecialUnitsRulesFragment}
`;

export const onCreateSpecialUnitsItem = gql`
	subscription onCreateSpecialUnitsItem($_id: String) {
		onCreateSpecialUnitsItem(_id: $_id) {
			_id
			lastModifiedBy {
				fullName
			}
			lastModifiedOn
			units {
				_id
				commission {
					input
					value
				}
				createdBy {
					fullName
				}
				createdAt
				description
				stockNumber
				hierarchy
				isParent
				search
				criteria
				inventoryList {
					_id
					hierarchy
					isParent
					inventory {
						_id
						createdAt
						locationId
						status
						properties {
							displayName
							dataType
							value
						}
						updatedAt
						averageAge
					}
				}

				lastModifiedOn
			}
		}
	}
`;

export const onUpdateSpecialUnitsItem = gql`
	subscription onUpdateSpecialUnitsList($_id: String) {
		onUpdateSpecialUnitsList(_id: $_id) {
			_id
			lastModifiedBy {
				fullName
			}
			lastModifiedOn
			units {
				commission {
					input
					value
				}
				createdBy {
					fullName
				}
				createdAt
				_id
				description
				lastModifiedOn
				stockNumber
				vin
			}
		}
	}
`;

export const onDeleteSpecialUnitsItem = gql`
	subscription onDeleteSpecialUnitsItem($_id: String) {
		onDeleteSpecialUnitsItem(_id: $_id) {
			_id
			lastModifiedBy {
				fullName
			}
			lastModifiedOn
			units {
				_id
				commission {
					input
					value
				}
				createdBy {
					fullName
				}
				createdAt
				description
				stockNumber
				hierarchy
				isParent
				search
				criteria
				inventoryList {
					_id
					hierarchy
					isParent
					inventory {
						_id
						createdAt
						locationId
						status
						properties {
							displayName
							dataType
							value
						}
						updatedAt
						averageAge
					}
				}
				lastModifiedOn
			}
		}
	}
`;

export const onUpdateManagedSpecialUnitsList = gql`
	subscription onUpdateManagedSpecialUnitsList($locationId: String, $commissionCycleId: String) {
		onUpdateManagedSpecialUnitsList(locationId: $locationId, commissionCycleId: $commissionCycleId) {
			locationId
			commissionCycleId
			transactionType
			specialUnitsLists {
				_id
				title
				effectiveDateFrom
				effectiveDateTo
				createdAt
				lastModifiedOn
				unitsCount
				createdBy {
					fullName
				}
				units {
					_id
					hierarchy
					isParent
					search
					criteria
					inventoryList {
						_id
						hierarchy
						isParent
						inventory {
							_id
							createdAt
							locationId
							averageAge
							status
							properties {
								displayName
								dataType
								value
							}
							updatedAt
						}
					}
					commission {
						input
						value
					}
					createdBy {
						fullName
					}
					createdAt
					lastModifiedOn
				}
			}
			targetIds
		}
	}
`;
